var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 13.7933L10.7238 10.0173C11.6312 8.92796 12.0837 7.53072 11.9871 6.11625C11.8906 4.70179 11.2524 3.379 10.2054 2.42306C9.15843 1.46712 7.78318 0.951639 6.36579 0.983845C4.9484 1.01605 3.59799 1.59347 2.59548 2.59597C1.59298 3.59848 1.01556 4.94889 0.983357 6.36628C0.951151 7.78367 1.46663 9.15892 2.42257 10.2059C3.37851 11.2529 4.7013 11.8911 6.11577 11.9876C7.53023 12.0842 8.92747 11.6317 10.0168 10.7243L13.7928 14.5003L14.4998 13.7933ZM1.99981 6.5003C1.99981 5.61029 2.26373 4.74026 2.7582 4.00024C3.25267 3.26021 3.95547 2.68344 4.77774 2.34284C5.60001 2.00225 6.50481 1.91313 7.37772 2.08677C8.25063 2.2604 9.05246 2.68899 9.68179 3.31832C10.3111 3.94766 10.7397 4.74948 10.9133 5.6224C11.087 6.49531 10.9979 7.40011 10.6573 8.22238C10.3167 9.04464 9.7399 9.74745 8.99988 10.2419C8.25986 10.7364 7.38983 11.0003 6.49981 11.0003C5.30675 10.999 4.16292 10.5244 3.31929 9.68082C2.47567 8.83719 2.00114 7.69337 1.99981 6.5003Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8e817dc0a960dc8580550dede32f39fc.svg";
export { ForwardRef as ReactComponent };